import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import MaskedInput from 'react-text-mask';

import Progress from '../components/Progress';

@inject('AuthenticationStore') @observer
export default class Login extends Component {
	handleSubmitLogin(event) {
		const { AuthenticationStore } = this.props;
		event.preventDefault();
		AuthenticationStore.login();
	}

	handleSubmitUpdateEmail(event) {
		const { AuthenticationStore } = this.props;
		event.preventDefault();
		AuthenticationStore.updateEmail();
	}

	render() {
		const { AuthenticationStore } = this.props;
		return (
			<div id="login" className="wrapper">
				{ AuthenticationStore.userCanAccess && <Redirect to="/novidades" /> }

				<section className="stripe-top-logo">
					<img alt="" src={require("../img/logo.svg")}/>

					{ AuthenticationStore.isSending && <Progress/> }
				</section>

				{ !AuthenticationStore.isAuthenticated && (
					<form className="form-login" onSubmit={this.handleSubmitLogin.bind(this)}>
						<p className={ AuthenticationStore.inputCpf.valid ? 'cpf' : 'cpf error' }>
							<label htmlFor="cpf">Seu CPF/CNPJ</label>
							<MaskedInput
								mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
								type="text"
								name="cpf"
								guide={false}
								placeholder="somente números"
								value={AuthenticationStore.cpf}
								onChange={(ev) => AuthenticationStore.setInputCpf(ev.target.value)} />
							<img alt="" src={require('../img/icon-card.svg')}/>
						</p>

						<button className={ AuthenticationStore.isSending ? 'disabled' : ''}>Entrar
							<div>
								<img alt="" src={require("../img/icon-arrow-right.svg")} className="normal"/>
								<img alt="" src={require("../img/icon-arrow-right-hover.svg")} className="hover"/>
							</div>
						</button>
						{ AuthenticationStore.errorMessage && (
							<span className="errorMessage">{AuthenticationStore.errorMessage}</span>
						)}
					</form>
				)}

				{ AuthenticationStore.isAuthenticated && !AuthenticationStore.userDidUpdateEmail && (
					<form className="form-login" onSubmit={this.handleSubmitUpdateEmail.bind(this)}>
            <p className={ AuthenticationStore.inputEmail.valid ? 'email' : 'email error' }>
              <label htmlFor="email">Seu e-mail</label>
              <input
                type="text"
                name="email"
								placeholder="E-mail"
                value={AuthenticationStore.email}
                onChange={(ev) => AuthenticationStore.setInputEmail(ev.target.value)} />
              <img alt="" src={require('../img/icon-message.svg')}/>
            </p>

						<button className={ AuthenticationStore.isSending ? 'disabled' : ''}>Continuar
							<div>
								<img alt="" src={require("../img/icon-arrow-right.svg")} className="normal"/>
								<img alt="" src={require("../img/icon-arrow-right-hover.svg")} className="hover"/>
							</div>
						</button>
						{ AuthenticationStore.errorMessage && (
							<span className="errorMessage">{AuthenticationStore.errorMessage}</span>
						)}
					</form>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/screens/Login.js